import React from "react";
import ReactDOM from "react-dom/client";
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import "@fontsource/inter";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css"
import "./index.css";
import { BrowserRouter, ScrollRestoration } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import Main from "./main-wrapper/Routes";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <Main />
    </BrowserRouter>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
